var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInprogrss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52596 3.08507L12.7399 6.90684C13.1594 7.08084 13.42 7.47098 13.42 7.925C13.42 8.37902 13.1594 8.76916 12.7399 8.94316L3.52596 12.7649C3.13848 12.9256 2.69986 12.8557 2.38151 12.5802C2.06376 12.3052 1.93089 11.8815 2.03474 11.4744L2.94017 7.925L2.03474 4.37562C1.93089 3.96854 2.06378 3.54484 2.38153 3.26984C2.69928 2.99488 3.13779 2.92405 3.52596 3.08507Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogrss);
export default __webpack_public_path__ + "static/media/inprogrss.292f0597574007fb060abaffe330c06c.svg";
export { ForwardRef as ReactComponent };